<template>
  <div>
    <v-data-table
      :headers="[
        { text: 'Ärende', sortable: false, filterable: false, value: 'name' },
        { text: 'Ärendenr', sortable: false, filterable: false, value: 'id' },
        { text: 'Datum', sortable: false, filterable: false, value: 'date' },
        { text: 'Kontaktperson', sortable: false, filterable: false, value: 'contact' },
        { text: 'Arbetsgivare', sortable: false, filterable: false, value: 'company' },
        { text: 'Status', sortable: false, filterable: false, value: 'state' },
        { text: '', sortable: false, value: 'actions', align: 'right' },
      ]"
      :items="items"
      :loading="isLoading"
      :items-per-page="1000"
      hide-default-footer
      item-key="index"
    >
      <template slot="item.date" slot-scope="props">{{
        props.item.date | date
      }}</template>
      <template slot="item.id" slot-scope="props">{{
        get(props, 'item.id' , '')
      }}</template>
      <template slot="item.contact" slot-scope="props">
        <router-link :to="'/people/' + props.item.contactId">{{
          props.item.contact
        }}</router-link>
      </template>
      <template slot="item.company" slot-scope="props">
        <router-link :to="'/companies/' + props.item.companyId">{{
          props.item.company
        }}</router-link>
      </template>
      <template slot="item.state" slot-scope="props">
        <!-- <span v-if="(props.item.state=='wait')" class="small"> -->
        {{ props.item.state }}
      </template>
      <template slot="item.actions" slot-scope="props">
        <div class="d-flex justify-end">
          <v-btn
            v-if="props.item.actions == 'showApplication'"
            class="ml-4"
            text
            @click="showApplication(props.item.id)"
            ><v-icon>$sl-view-on</v-icon>
          </v-btn>
          <v-btn
            v-else-if="props.item.actions == 'bookPauseModal'"
            class="ml-4"
            text
            @click="
              pauseMode = 'show'
              modalObj = getPauseObj(props.item.id, props.item.bookId, props.item.educationId)
              pauseModal = true
            "
            ><v-icon>$sl-view-on</v-icon>
          </v-btn>
          <v-btn
            v-else-if="props.item.actions == 'approveQualificationTimeModal'"
            class="ml-4"
            text
            @click="
              qualificationObj = props.item
              qualificationModal = true
            "
            ><v-icon>$sl-view-on</v-icon>
          </v-btn>
          <v-btn
            v-else-if="props.item.actions == 'qualificationTimeModal'"
            class="ml-4"
            text
            @click="
              qualificationObj = props.item
              qualificationModal = true
            "
            ><v-icon>$sl-view-on</v-icon>
          </v-btn>
          <v-btn
            v-else-if="props.item.actions == 'basicEducationTimeModal'"
            class="ml-4"
            text
            @click="
              basicEducationObj = props.item
              basicEducationTimeModal = true
            "
            ><v-icon>$sl-view-on</v-icon>
          </v-btn>
          <v-btn
            v-else-if="props.item.actions == 'extendEducationModalVisible'"
            class="ml-4"
            text
            @click="
              extendedEducationObj = props.item
              extendEducationModalVisible = true
            "
            ><v-icon>$sl-view-on</v-icon>
          </v-btn>
          <v-btn
            v-else-if="
              props.item.actions == 'approveEbook' || props.item.actions == 'approved'
            "
            class="ml-4"
            text
            @click="showEbookModal(props.item.selectedBook)"
            ><v-icon>$sl-view-on</v-icon>
          </v-btn>
          <v-btn
            v-else-if="props.item.actions == 'showEbook'"
            class="ml-4"
            text
            @click="showEbookModal(props.item.selectedBook)"
            ><v-icon>$sl-view-on</v-icon>
          </v-btn>
          <v-btn
            v-else-if="props.item.actions === 'specialCourseApproval'"
            class="ml-4"
            text
            @click="openSpecialCourseApprovalDialog(props.item)"
            ><v-icon>$sl-view-on</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
    <v-dialog v-model="pauseModal" :max-width="720">
      <PersonCasesPauseModal
        :mode="pauseMode"
        :bookPauseObj="modalObj"
        @close="closePauseModal"
      />
    </v-dialog>
    <v-dialog v-model="ebookModal" :max-width="1000">
      <PersonEbookModal
        :selectedBook="selectedBook"
        :person="selectedPerson"
        @close="ebookModal = false"
        @saved="init()"
      />
    </v-dialog>
    <v-dialog v-model="qualificationModal" :max-width="720">
      <QualificationTimeModal
        :QTM="qualificationObj"
        :paused="pausedQTMS"
        @close="
          qualificationModal = false
          getQualificationTime()
        "
      />
    </v-dialog>
    <v-dialog v-model="basicEducationTimeModal" :max-width="720">
      <BasicEducationTimeModal
        :ETM="basicEducationObj"
        :approvedExtensions="approvedExtensions"
        @close="
          basicEducationTimeModal = false
          getBasicEducationTime()
        "
      />
    </v-dialog>
    <v-dialog v-model="extendEducationModalVisible" :max-width="720">
      <BasicEducationTimeModal
        :ETM="extendedEducationObj"
        :approvedExtensions="approvedExtensions"
        :isVisible="extendEducationModalVisible"
        @close="extendEducationModalVisible = false"
      />
    </v-dialog>
    <v-dialog v-model="specialCourseApprovalModalVisible" :max-width="600">
      <PersonEbookSpecialCourseApprovalModal
        :course-prop="selectedSpecialCourse"
        :visible="specialCourseApprovalModalVisible"
        @close="specialCourseApprovalModalVisible = false"
        @on-confirm="onSpecialCourseConfirm()"
      />
    </v-dialog>
  </div>
</template>

<script>
import API from "@/services/api.js"
import { mapGetters, mapActions } from "vuex"
import find from "lodash/find"
import uniqBy from "lodash/uniqBy";
import findIndex from "lodash/findIndex"
import filter from "lodash/filter"
import PersonCasesPauseModal from "@/components/person/PersonCasesPauseModal"
import PersonEbookModal from "@/components/person/PersonEbookModal"
import QualificationTimeModal from "@/components/person/qualificationtime/qualificationTimeModal"
import BasicEducationTimeModal from '@/components/person/PersonEbooks/BasicEducationTimeModal'
import PersonEbookSpecialCourseApprovalModal from '@/components/person/PersonEbooks/PersonEbookSpecialCourseApprovalModal'
import get from "lodash/get";

// @group Person
// PersonCases component
export default {
  name: "PersonCases",

  data: () => ({
    pauseModal: false,
    pauseMode: "show",
    ebookModal: false,
    selectedBook: {},
    modalObj: {},
    qualificationModal: false,
    basicEducationTimeModal: false,
    qualificationObj: {},
    basicEducationObj: {},
    books: [],
    educations: [],
    applications: [],
    qualificationTimes: [],
    educationPauses: [],
    basicEducationTimes: [],
    extendEducationModalVisible: false,
    extendedEducations: [],
    extendedEducationObj: {},
    specialCourseApprovalModalVisible: false,
    selectedSpecialCourse: null
    // book: null
    //items: []
  }),
  components: {
    PersonCasesPauseModal,
    QualificationTimeModal,
    PersonEbookModal,
    BasicEducationTimeModal,
    PersonEbookSpecialCourseApprovalModal
  },
  computed: {
    ...mapGetters("currentuser", ["currentUser"]),
    ...mapGetters("app", ["isLoading"]),
    ...mapGetters("person", ["selectedPerson"]),
    items() {
      var ret = []
      ret = this.getBookPauses()
        .concat(this.books)
        .concat(this.applications)
        .concat(this.newLengthQTMS)
        .concat(this.educationPauses)
        .concat(this.basicEducationTimes)
        .concat(this.extendedEducations)
        .concat(this.qualificationTimes)
        .concat(this.specialCourseApprovals)
      return uniqBy(ret, "id")
    },
    approvedExtensions() {
      return (this.extendedEducations || []).filter(it => it.issuerId && it.approvedBySecondaryId);
    },
    pausedQTMS() {
      return filter(this.qualificationTimes, ["type", "modification"])
    },
    newLengthQTMS() {
      return filter(this.qualificationTimes, o => o.type === "overwrite" || o.type === "cancellation" )
    },

    personApprenticeship() {
      return item => this.selectedPerson?.apprenticeships.filter(apprenticeship => item.apprenticeships.some(o => o.id === apprenticeship.id))[0]
    },

    specialCourseApprovals() {
      const books = get(this, 'selectedPerson.books', []).filter(b => get(b, 'specialCourseApprovals', []).length)
      const specialCoursesApprovals = books.map(b => b.specialCourseApprovals).flat()

      const getBookInfo = (bookId) => get(this, 'books', []).find(b => b.id === bookId)
      const getStatus = (course) => {
        const status = get(course, 'status', null)
        const approvedByCurrentUser = get(course, 'approvedById', null) === get(this, 'currentUser.id', null)
        if ( status === 'approved' ) return 'Godkänd och klarmarkerad'
        if ( approvedByCurrentUser ) return 'Du har redan klarmarkerat detta ärende'
        if ( status === 'pending_second_approval' ) return 'Väntar på klarmarkering'
        return null
      }

      return specialCoursesApprovals.map(c => ({
        id: c.id,
        name: c.status === 'approved' ? 'Fördjupningskurs' : 'Klarmarkera fördjupningskurs',
        date: c.createdAt,
        contact: getBookInfo(c.bookId)?.contact,
        company: getBookInfo(c.bookId)?.company,
        state: getStatus(c),
        actions: 'specialCourseApproval',
        approvedById: c.approvedById,
      }))
    }
  },

  watch: {
    "selectedPerson": {
      handler: function () {
        this.init()
      },
    },
    extendEducationModalVisible: {
      handler(val) {
        if(!val) return this.getBasicEducationTime()
      }
    }
  },

  created() {
    this.init()
  },

  methods: {

    get,
    
    init() {
      this.educations = []
      this.books = []
      this.applications = []
      this.educationPauses = []
      this.getBooks()
      this.getEducationPauses()
      this.fetchApplications()
      this.getQualificationTime()
      this.getBasicEducationTime()
    },

    closePauseModal(updated) {
      if(updated==true)
        this.init()

      this.pauseModal = false
    },
    getBook(bookId) {
      let arr = {}

      API.getBook(bookId)
        .then((response) => {
          let date = response.data.createdAt,
          contactName = "",
          caseName='E-bok',
          contactId = "",
          state = "",
          actions = "showEbook",
          selectedBook = response.data
          
          if (
            response.data.approvedByInstructorId &&
            response.data.approvedByInstructorId > 0 &&
            response.data.education.basicEducationCertificate &&
            response.data.education.basicEducationCertificate.approvedById &&
            response.data.education.basicEducationCertificate.approvedById > 0
          ) {
            caseName="Grundutbildning"
            state = "Godkänd"
          } else if (
            response.data.approvedByInstructorId &&
            response.data.approvedByInstructorId > 0 &&
            response.data.education.basicEducationCertificate &&
            response.data.education.basicEducationCertificate.createdById &&
            response.data.education.basicEducationCertificate.createdById > 0
          ) {
            state = "Väntar på godk."
            caseName="Grundutbildning"
            if (
              response.data.education &&
              response.data.education.basicEducationCertificate &&
              response.data.education.basicEducationCertificate.createdBy &&
              response.data.education.basicEducationCertificate.createdBy.id ==
                this.currentUser.id
            ) {
              state = "Väntar på godkännande av annan regionär"
              caseName="Grundutbildning"
            } else {
              state = "Väntar på godk."
              caseName="Grundutbildning"
            }
          } else if (
            response.data.approvedByInstructorId &&
            response.data.approvedByInstructorId > 0
          ) {
            state = "Väntar på godk."
            caseName="Grundutbildning"
          } else {
            state = "Pågående"
            actions = ""
          }

          const instructors = get(response, 'data.apprenticeship.apprenticeshipInstructors', [])
          const instructorWithEmployment = instructors.find(({ instructor }) => instructor)
          if ( !instructorWithEmployment ) throw new Error('Personen med handledarroll är inte längre anställd på företaget.')

          const { id, firstName, lastName } = get(instructorWithEmployment, 'instructor.employed', {})
          contactId = id
          contactName = `${ firstName } ${ lastName }`

          const book = get(this, 'selectedPerson.books', []).find(({ id }) => id === bookId)
          if ( !book ) throw new Error('E-bok kunde inte hittas')
          const company = get(book, 'apprenticeship.company', {})
          
          arr = {
            id: bookId,
            name: caseName,
            date,
            contact: contactName,
            contactId,
            company: get(company, 'name', ''),
            companyId: get(company, 'id', 0),
            state,
            actions,
            selectedBook,
          }

          this.books.push(arr)
          this.books = uniqBy(this.books, "id");
        })
        .catch((error) => {
          console.log("There was an error:", error)
        })
        .finally((f) => {
          return arr
        })
    },
    getBooks() {
      this.books = []
      this.selectedPerson.books.forEach((b) => {
        this.getBook(b.id)
      })
    },
    getEducationPauses () {
      //console.log("edu::", this.selectedPerson.educations)
      this.selectedPerson.educations.forEach(e => {
        //this.getBook(b.id)
        if(e.qualificationTimePauses && e.qualificationTimePauses.length>0)
        {
          let companyName = (e.currentApprenticeship && e.currentApprenticeship.company && e.currentApprenticeship.company.name) ? e.currentApprenticeship.company.name : '-'
          let companyId = (e.currentApprenticeship && e.currentApprenticeship.company && e.currentApprenticeship.company.id) ? e.currentApprenticeship.company.id : '0'
          e.qualificationTimePauses.forEach(q => {
          let contact = { name: '', id: -1}

          contact.name = (q.createdBy && q.createdBy.firstName) ? q.createdBy.firstName + " " : '' + (q.createdBy && q.createdBy.lastName) ? q.createdBy.lastName : ''
          contact.id = (q.createdBy && q.createdBy.id) ? q.createdBy.id : -1

          let state ='Väntar på godk.'

          if(q.approved==true)
            state = 'Godkänd'

          else if (q.rejectedById && q.rejectedById > 0) state = "Nekad"

          else if(q.approvedById && q.approvedById > 0 && this.currentUser.id == q.approvedById)
            state = 'Väntar på godkännande av annan regionär'

          let arr = {
            id: q.id,
            name: "Ansökan om uppehåll (kvalificeringstid)",
            date: q.createdAt,
            contact: contact.name,
            contactId: contact.id,
            educationId: e.id,
            bookId: -1,
            company: companyName,
            companyId: companyId,
            state: state,
            actions: "bookPauseModal",
          }
          this.educationPauses.push(arr)
          })
        }
      })

    },
    getEbookBtnText(book) {
      if (
        book.education &&
        book.education.basicEducationCertificate &&
        book.education.basicEducationCertificate.createdById &&
        book.education.basicEducationCertificate.createdById > 0
      ) {
        return "Godkänn grundutb."
      }
      return "Utfärda grundutb."
    },
    getBookPauses() {
      var ret = []
      let obj = {}
      let contactName = "",
        contactId = -1,
        companyId = -1,
        companyName = "",
        bookId = -1,
        state = ""

      this.selectedPerson.books.forEach((book) => {
        if (
          book.apprenticeship &&
          book.apprenticeship.company &&
          book.apprenticeship.company.name
        )
          companyName = book.apprenticeship.company.name

        book.bookPauses.forEach((pause) => {
          if (pause.bookId) bookId = pause.bookId
          if (
            book.apprenticeship &&
            book.apprenticeship.company &&
            book.apprenticeship.company.id
          )
            companyId = book.apprenticeship.company.id
          if (pause.createdBy && pause.createdBy.id) contactId = pause.createdBy.id
          if (pause.createdBy && pause.createdBy.firstName)
            contactName = pause.createdBy.firstName + " "
          if (pause.createdBy && pause.createdBy.lastName)
            contactName = contactName + pause.createdBy.lastName
          if (pause.rejectedById && pause.rejectedById > 0) state = "Nekad"
          else if (pause.approvedBySecondaryId && pause.approvedBySecondaryId > 0)
            state = "Godkänd"
          else if (
            pause.approvedById &&
            pause.approvedById > 0 &&
            this.currentUser.id == pause.approvedById
          )
            state = "Väntar på godkännande av annan regionär"
          else state = "Väntar på godk."

          obj = {
            id: pause.id,
            name: "Ansökan om uppehåll (grundutbildning)",
            date: pause.createdAt,
            contact: contactName,
            contactId: contactId,
            bookId: bookId,
            educationId: -1,
            company: companyName,
            companyId: companyId,
            state: state,
            actions: "bookPauseModal",
          }
          ret.push(obj)
        })
      })
      return ret
    },
    getPauseObj(id, bookId, educationId) {
      let bp = {}
      if(bookId > 0) {
        let findBook = find(this.selectedPerson.books, { id: bookId })
        if (findBook) {
          bp = find(findBook.bookPauses, { id: id })
          if(!bp.regionId) {
            bp.regionId = findBook.regionId
          }
        }
      }
      else if(educationId > 0) {
        let findEducation = find(this.selectedPerson.educations, { id: educationId })
        if (findEducation) {
          bp = find(findEducation.qualificationTimePauses, { id: id })
          if(!bp.regionId) {
            bp.regionId = findEducation.regionId
          }
        }
      }
      return bp
    },

    fetchApplications() {
      if (!this.selectedPerson) return

      API.listApplications({
        startAt: 0,
        sortBy: "lastName",
        sortDesc: "ASC",
        advSearch: { personalNumber: this.selectedPerson.personalNumber },
        pageSize: 1000,
      })
        .then((response) => {
          //this.applications = response.data.rows
          let obj = {}
          let contactName = "",
            contactId = -1,
            companyId = -1,
            companyName = "",
            state = ""

          response.data.rows.forEach((ap) => {
            if (ap.state && ap.state.name) state = ap.state.name
            if ( ap.company ) {
              companyName = ap.company?.name
              companyId = ap.company?.id
            }

            if (
              ap.instructor &&
              ap.instructor.employed &&
              ap.instructor.employed.fullName
            )
              contactName = ap.instructor.employed.fullName

            let stateText = state
            
            if ( ap.transferOldProfession ) {
              if ( [3, 7].includes(ap?.state?.id) ) 
                stateText = 'Förflyttning bekräftad och godkänd av företag'
              if ( ap?.state?.id === 11 && !ap?.transferOldProfessionApproved )
                if ( this.currentUser?.id === ap?.transferApprovedById )
                  stateText = '(Förflyttning) Väntar på godk. av annan regionär'
                else 
                  stateText = '(Förflyttning) Väntar på godk.'
            }

            obj = {
              id: ap.id,
              name: "Lärlingsanmälan",
              date: ap.createdAt,
              contact: contactName,
              contactId: contactId,
              bookId: -1,
              company: companyName,
              companyId: companyId,
              state: stateText,
              actions: "showApplication",
            }
            this.applications.push(obj)
          })
        })
        .catch((error) => {
          console.log("There was an error:", error.response)
        })
    },
    getQualificationTime() {
      this.qualificationTimes = []
      API.listPersonEducations(this.selectedPerson.id)
        .then((res) => {
          let state = "",
            company = "",
            companyId = null

          res.data.forEach((ed) => {

            if (ed.qualificationTime?.qualificationTimeModifications) {
                ed.qualificationTime?.qualificationTimeModifications?.forEach((qt) => {
                  if (qt.rejectedById && qt.rejectedById > 0) state = "Nekad"
                  else if (qt.approvedBySecondaryId && qt.approvedBySecondaryId > 0)
                    state = "Godkänd"
                  else if (
                    qt.approvedById &&
                    qt.approvedById > 0 &&
                    this.currentUser.id == qt.approvedById
                  )
                    state = "Väntar på godkännande av annan regionär"
                  else state = "Väntar på godk."

                  if (
                    ed &&
                    ed.apprenticeships[0] &&
                    ed.apprenticeships[0].company &&
                    ed.apprenticeships[0].company.name
                  ) {
                    company = ed.apprenticeships[0].company.name
                    companyId = this.personApprenticeship(ed)?.company?.id
                  }

                  this.qualificationTimes.push({
                    id: qt.id,
                    qualificationId: ed.qualificationTime?.id,
                    name: 'Kvalificeringstid',
                    regionId: ed.regionId,
                    qualificationTimeFromDate: qt.qualificationTimeStartDate || ed.qualificationTime.fromDate,
                    qualificationTimeToDate: qt.qualificationTimeEndDate || ed.qualificationTime.toDate,
                    company: company ? company : "",
                    companyId: companyId ?? '',
                    name: qt.lengthInMonths ? "Ändring av kvalificeringstid" : "Avbruten kvalificeringstid",
                    date: qt.fromDate,
                    /*  qualificationTimeModification: qt, */
                    state: state,
                    actions: "qualificationTimeModal",
                    approved: qt.approved,
                    approvedAt: qt.approvedAt,
                    approvedById: qt.approvedById,
                    approvedBySecondaryId: qt.approvedBySecondaryId,
                    approvedBySecondaryAt: qt.approvedBySecondaryAt,
                    fromDate: qt.fromDate,
                    lengthInMonths: qt.lengthInMonths,
                    reason: qt.reason,
                    rejected: qt.rejected,
                    rejectedById: qt.rejectedById,
                    status: qt.status,
                    toDate: qt.toDate,
                    approvedBySecondary: qt.approvedBySecondary,
                    approvedBy: qt.approvedBy,
                    type: qt.type,
                    updatedAt: qt.updatedAt,
                    educationId: ed?.id,
                    companyModification: ed?.qualificationTime?.companyModification || 0,
                    overwrite: qt?.overwrite || false
                  })
                })
            }

            if(ed.qualificationTime?.isApprovedByInstructor) {
              if (ed.qualificationTime.approvedBySecondaryId > 0)
                state = "Godkänd"
              else if (ed.qualificationTime.approvedById > 0 && this.currentUser.id == ed.qualificationTime.approvedById)
                state = "Väntar på godkännande av annan regionär"
              else state = "Väntar på godk."

              const activeApprenticeship = filter(get(this, 'selectedPerson.apprenticeships', []), ['manuallyEndedDate', null])[0]
              if (  get(activeApprenticeship, 'company.name', null) ) {
                company = get(activeApprenticeship, 'company.name', '')
                companyId = get(activeApprenticeship, 'company.id', '')
              }

              const contact = activeApprenticeship?.apprenticeshipInstructors?.find(item => item.isActive)

              this.qualificationTimes.push({
                id: ed.qualificationTime.id,
                name: 'Kvalificeringstid',
                regionId: ed.regionId,
                qualificationId: ed.qualificationTime?.id,
                qualificationTimeFromDate: ed.qualificationTime.fromDate,
                qualificationTimeToDate: ed.qualificationTime.toDate,
                company: company ? company : "",
                companyId: companyId ?? '',
                state: state,
                contact: contact?.instructor?.employed?.fullName ?? '',
                contactId: contact?.instructor?.employed?.id ?? -1,
                actions: "approveQualificationTimeModal",
                isApproved: ed.qualificationTime.isApproved,
                approvedAt: ed.qualificationTime?.approvedAt,
                approvedById: ed.qualificationTime.approvedById,
                approvedBySecondaryId: ed.qualificationTime.approvedBySecondaryId,
                fromDate: ed.qualificationTime.fromDate,
                date: ed.qualificationTime.fromDate,
                approvedBySecondaryAt: ed.qualificationTime?.approvedBySecondaryAt,
                toDate: ed.qualificationTime.toDate,
                approvedBySecondary: ed.qualificationTime.approvedBySecondary,
                approvedBy: ed.qualificationTime.approvedBy,
                updatedAt: ed.qualificationTime.updatedAt,
                educationId: ed?.id
              })
            }
          })
        })
        .catch((error) => {
          console.log("get document error, ", error)
        })
    },
    getBasicEducationTime() {
      this.basicEducationTimes = []
      this.extendedEducations = []
      API.listPersonEducations(this.selectedPerson.id)
        .then((res) => {
          let state = "",
            company = "",
            companyId = null

          res.data.forEach((ed) => {
            if (ed.basicEducationTimeModifications?.length > 0 || ed?.educationExtensions?.length > 0) {

              ed?.basicEducationTimeModifications?.forEach((eT) => {
                if (eT.rejectedById > 0) state = "Nekad"
                else if (eT.approvedBySecondaryId && eT.approvedBySecondaryId > 0)
                  state = "Godkänd"
                else if (
                  eT.approvedById > 0 &&
                  this.currentUser.id == eT.approvedById
                )
                  state = "Väntar på godkännande av annan regionär"
                else state = "Väntar på godk."

                if (
                  ed &&
                  ed.apprenticeships[0] &&
                  ed.apprenticeships[0].company &&
                  ed.apprenticeships[0].company.name
                ) {
                  company = ed.apprenticeships[0].company.name
                  companyId = this.personApprenticeship(ed)?.company?.id
                }

                this.basicEducationTimes.push({
                  id: eT.id,
                  regionId: ed.regionId,
                  educationTimeFromDate: eT.fromDate,
                  educationTimeToDate: ed.calculatedEndDate,
                  company: company ? company : "",
                  companyId: companyId ?? '',
                  name: eT.lengthInMonths ? 'Ändring av grundutbildningstid' : 'Avbruten grundutbildningstid',
                  date: eT.fromDate,
                  state: state,
                  actions: "basicEducationTimeModal",
                  approved: eT.approved,
                  approvedAt: eT.approvedAt,
                  approvedById: eT.approvedById,
                  approvedBySecondaryId: eT.approvedBySecondaryId,
                  fromDate: eT.fromDate,
                  lengthInMonths: eT.lengthInMonths,
                  rejectedById: eT.rejectedById,
                  toDate: ed.calculatedEndDate,
                  approvedBySecondary: eT.approvedBySecondary,
                  approvedBy: eT.approvedBy,
                  updatedAt: eT.updatedAt,
                })
              })

              ed.educationExtensions.forEach((extension) => {

                if (extension?.rejectedById > 0) state = "Nekad"

                const isPendingOrder = Boolean(extension?.extensionOrders.length && extension?.extensionOrders?.some(o => o.educationExtensionId === extension.id && o.state.id === 1))
                if ( isPendingOrder )
                  state = 'Väntar på godkännande av företag'
                else if (extension?.approvedBySecondaryId > 0)
                  state = "Godkänd"
                else if (
                  extension?.issuerId > 0 &&
                  this.currentUser.id === extension?.issuerId
                )
                  state = "Väntar på godkännande av annan regionär"
                else state = "Väntar på godk."

                if (ed?.apprenticeships[0]?.company?.name) {
                  company = ed.apprenticeships[0].company.name
                  companyId = this.personApprenticeship(ed)?.company?.id
                }

                //- Get book pause
                const bookPause = this.selectedPerson.books[0].bookPauses[0]

                if(ed.id === extension.educationId) {
                  this.extendedEducations.push({
                    id: extension.id,
                    extension: extension.distanceEducationProviderExtension,
                    extensionOrders: extension.extensionOrders,
                    regionId: ed.regionId,
                    company: company ?? '',
                    companyId: companyId ?? '',
                    name: 'Förlängning (grundutbildningstid)',
                    date: extension.createdAt,
                    state: state,
                    actions: "extendEducationModalVisible",
                    approved: extension.approved,
                    approvedAt: extension.createdAt,
                    approvedById: extension.issuerId,
                    approvedAtSecondary: new Date(),
                    approvedBySecondaryId: extension.approvedBySecondaryId,
                    fromDate: extension.educationOldStartDate || ed.startDate,
                    rejectedById: extension.rejectedById,
                    toDate: extension.educationOldEndDate || ed.endDate,
                    issuedAt: extension.issuedAt || extension.createdAt,
                    lengthInMonths: extension.distanceEducationProviderExtension.months,
                    approvedBySecondary: extension.approvedBySecondary,
                    approvedBy: extension.approvedBy,
                    updatedAt: extension.updatedAt,
                    bookPause
                  })
                }
              })
            }
          })
        })
        .catch((error) => {
          console.log("get document error, ", error)
        })
    },

    showEbookModal(book) {
      this.ebookModal = true
      this.selectedBook = book
    },
    showApplication(id) {
      this.$router.push({ name: "Application", params: { id: id } }).catch(() => {})
    },
    monthDiff(d1, d2) {
      var months
      months = (d2.getFullYear() - d1.getFullYear()) * 12
      months -= d1.getMonth()
      months += d2.getMonth()
      return months <= 0 ? 0 : months
    },
    openSpecialCourseApprovalDialog(course) {
      if ( !course ) return
      this.selectedSpecialCourse = course
      this.specialCourseApprovalModalVisible = true
    },
    onSpecialCourseConfirm() {
      this.specialCourseApprovalModalVisible = false
      this.$emit('fetch-person')
    },
  },
}
</script>

<style></style>
